import { useQuery } from "@tanstack/react-query";
import _ from "lodash";
import { useState } from "react";

import { LocationData } from "../../../models/LocationData";
import DataSvc from "../../../services/dataSvc";

export const useLocationSelect = (organizationId?: string) => {
  const query = useQuery(["location-select", organizationId], async () => {
    const data = await DataSvc.getLocations(
      _.pickBy(
        {
          organization_id: organizationId ? [organizationId] : undefined,
          summary_mode: true,
          limit: 10000
        },
        (value: any) => {
          return !_.isUndefined(value) && !_.isNull(value);
        }
      )
    );
    setSelectedLocations(data?.list ?? []);
    return data;
  });

  const [selectedLocations, setSelectedLocations] = useState<LocationData[]>(
    query.data?.list ?? []
  );

  const toggleLocation = (location: LocationData) => {
    setSelectedLocations(
      selectedLocations.includes(location)
        ? selectedLocations.filter((l) => l.id !== location.id)
        : [...selectedLocations, location]
    );
  };

  const selectAll = () => {
    setSelectedLocations(query.data?.list ?? []);
  };

  const clearSelection = () => {
    setSelectedLocations([]);
  };

  return {
    allLocations: query.data?.list ?? [],
    selectedLocations,
    toggleLocation,
    selectAll,
    clearSelection
  };
};
